import { render, staticRenderFns } from "./activeticketlist.vue?vue&type=template&id=24a1087c"
import script from "./activeticketlist.vue?vue&type=script&lang=js"
export * from "./activeticketlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports